import React, { useState, useEffect, createContext, useContext } from 'react';

export const WindowDimensionsContext = createContext();

export const WindowDimensionsProvider = ({ children }) => {
  const [windowDimensions, setWindowDimensions] = useState({
    viewPortWidth: window.visualViewport.width,
    viewPortHeight: window.visualViewport.height
  });

  const handleResize = () => {
    setWindowDimensions({
      viewPortWidth: window.visualViewport.width,
      viewPortHeight: window.visualViewport.height
    });

  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <WindowDimensionsContext.Provider value={windowDimensions}>
      {children}
    </WindowDimensionsContext.Provider>
  );
};

export const useWindowDimensions = () => useContext(WindowDimensionsContext);